export var Frequency;
(function (Frequency) {
    Frequency["Fortnightly"] = "FORTNIGHTLY";
    Frequency["Monthly"] = "MONTHLY";
    Frequency["Quarterly"] = "QUARTERLY";
    Frequency["Weekly"] = "WEEKLY";
    Frequency["Yearly"] = "YEARLY";
})(Frequency || (Frequency = {}));
//# sourceMappingURL=Frequency.js.map